import React, { useState } from 'react';
import { Card, Button, Modal, Text, Group } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { Inertia } from '@inertiajs/inertia';

const DangerZoneCard = ({ eventId, eventName }) => {
  const [opened, setOpened] = useState(false);
  const [loading, setLoading] = useState(false);

  // Grab CSRF token from meta tag
  const csrfToken = document.querySelector("meta[name='csrf-token']")?.getAttribute('content');

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await fetch(`/events/${eventId}`, {
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken || '',
        },
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Deletion failed.');
      }

      // Assume the server returns a JSON with a message and redirect URL.
      const data = await response.json();

      showNotification({
        title: 'Event Deleted',
        message: data.message || 'Event has been successfully deleted.',
        color: 'green',
      });

      // Redirect using Inertia to the user profile page.
      Inertia.visit(data.redirect || '/users/profile');
    } catch (error) {
      showNotification({
        title: 'Deletion Error',
        message: error.message || 'An error occurred while deleting the event.',
        color: 'red',
      });
    } finally {
      setLoading(false);
      setOpened(false);
    }
  };

  return (
    <Card shadow="sm" padding="xl" style={{ border: '3px solid red', backgroundColor: '#ffe5e5', marginTop: '10rem' }}>
      <Text c="red" fw="bold" style={{ fontSize: '2rem' }}>
        Danger Zone
      </Text>
      <Text mt="sm">
        This will delete the event <strong>{eventName}</strong>.
      </Text>
      <Button color="red" onClick={() => setOpened(true)} mt="md" size="lg">
        Delete Event
      </Button>

      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title="Confirm Delete"
        centered
        styles={{
          header: { backgroundColor: '#ffcccc' }, // light red header
          content: { backgroundColor: '#ffe5e5' }, // light red background
        }}
      >
        <Text mb="md">
          Are you sure you want to delete the event <strong>{eventName}</strong>? This action cannot be undone.
        </Text>
        <Group gap="lg" mt="xl" justify="flex-end">
          <Button color="gray" variant="filled" onClick={() => setOpened(false)} size="lg">
            Cancel
          </Button>
          <Button color="red" loading={loading} onClick={handleDelete} size="lg">
            Delete
          </Button>
        </Group>
      </Modal>
    </Card>
  );
};

export default DangerZoneCard;
